import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useNavigate } from 'react-router-dom';

const History = ({ showHeader = true }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [transactions, setTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const pageSize = 50;

  const authToken = useSelector((state) => state.user?.token);

  const fetchTransactions = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `http://159.203.35.6:8080/wallet/getTransactions?page=${page}&page_size=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const { transactions: fetchedTransactions, count } = response.data;
      setTransactions((prev) => [...prev, ...fetchedTransactions]);
      setTotalCount(count);
    } catch (err) {
      if (err?.response?.status === 403) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Please connect your wallet",
          showConfirmButton: false,
          timer: 2000,
          background: "#f44336",
          color: "#fff",
        });
        navigate("/connect-wal");
        return;
      }

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: err?.response?.data?.error || "Error fetching transactions",
        showConfirmButton: false,
        timer: 2000,
        background: "#f44336",
        color: "#fff",
      });
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    const input = document.createElement("input");
    input.value = text;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    const successful = document.execCommand("copy");
    document.body.removeChild(input);

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: successful ? "success" : "error",
      title: successful ? "Copied to clipboard!" : "Failed to copy!",
      showConfirmButton: false,
      timer: 2000,
      background: "#be6bed",
      color: "#fff",
    });
  };

  const chainIds = {
    1: "Ethereum",
    11155111: "Sepolia",
    101: "Solana Mainnet",
    103: "Solana devnet",
    80002: "Polygon Amoy",
    137: "Polygon",
    56: "Binance",
    97: "Binance Testnet",
    43114: "Avalanche Mainnet",
    43113: "Avalanche Fuji"
  };

  useEffect(() => {
    if (authToken) {
      fetchTransactions(currentPage);
    }
  }, [authToken, currentPage]);

  const renderSkeletonRow = () => (
    <tr>
      {Array(10).fill(0).map((_, idx) => (
        <td key={idx}>
          <div className="skeleton skeleton-text"></div>
        </td>
      ))}
    </tr>
  );

  return (
    <div className="newpool-back">
       <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            Lookna Wallet<span className="color-sp"> Transaction History </span>
           
          </h2>
          <p className="header-description">
          Explore diverse transactions—from automated actions to personalized transfers—all securely recorded in one Wallet history
          </p>
        </div>
        <div className="details-borders"></div>
      </div>
      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            rgba(240, 240, 240, 0.05) 25%,
            rgba(200, 200, 200, 0.2) 50%,
            rgba(240, 240, 240, 0.05) 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.3s infinite linear;
          border-radius: 6px;
        }

        @keyframes shimmer {
          0% {
            background-position: -150% 0;
          }
          100% {
            background-position: 150% 0;
          }
        }

        .skeleton-text {
          height: 14px;
          width: 80%;
          margin: 6px 0;
        }

        .skeleton-circle {
          height: 28px;
          width: 28px;
          border-radius: 50%;
          display: inline-block;
        }

        .skeleton-token {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
      `}</style>

      <h2
        style={{
         
          margin: '20px 0',
        }}
      >
    
      </h2>

      <div className="table-container-new custom-scrollbar">
        <table className="table-table-container">
          <thead className="active-header">
            <tr>
              <th>Hash</th>
              <th>Chain</th>
              <th>Type</th>
              <th>From</th>
              <th>To</th>
              <th>Value</th>
              <th>Symbol</th>
              <th>Link</th>
              <th>Transaction Fee</th>
              <th style={{ textAlign: "center" }}>Value USD</th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array(20).fill(0).map((_, idx) => <React.Fragment key={idx}>{renderSkeletonRow()}</React.Fragment>)
              : transactions.map((txn, index) => (
                  <tr key={txn._id || index}>
                    <td className="coin-name-cell" style={{ cursor: 'pointer', color: '#be6bed' }} onClick={() => copyToClipboard(txn.hash)} title="Click to copy hash">
                      {txn.hash?.slice(0, 10)}...
                    </td>
                    <td>{chainIds[txn.chainId]}</td>
                    <td>{txn.type}</td>
                    <td title={txn.from} style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer', color: '#be6bed' }} onClick={() => copyToClipboard(txn.from)}>
                      {txn.from?.slice(0, 6)}...{txn.from?.slice(-4)}
                    </td>
                    <td title={txn.to} style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer', color: '#be6bed' }} onClick={() => copyToClipboard(txn.to)}>
                      {txn.to?.slice(0, 6)}...{txn.to?.slice(-4)}
                    </td>
                    <td>{txn.value}</td>
                    <td>{txn.symbol}</td>
                    <td>
                      <a style={{ color: 'rgb(190, 107, 237)' }} href={txn.transactionUrl} target="_blank" rel="noopener noreferrer">
                        View
                      </a>
                    </td>
                    <td>{txn.transactionFee}</td>
                    <td style={{ textAlign: "center" }}>{txn.valueUSD || 0}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default History;
